import { render, staticRenderFns } from "./cgDetail.vue?vue&type=template&id=c3435bc8&scoped=true"
import script from "./cgDetail.vue?vue&type=script&lang=js"
export * from "./cgDetail.vue?vue&type=script&lang=js"
import style0 from "./cgDetail.vue?vue&type=style&index=0&id=c3435bc8&prod&scoped=true&lang=scss"
import style1 from "./cgDetail.vue?vue&type=style&index=1&id=c3435bc8&prod&scoped=true&lang=css"
import style2 from "./cgDetail.vue?vue&type=style&index=2&id=c3435bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3435bc8",
  null
  
)

export default component.exports